import React from 'react';
import PropTypes from 'prop-types';
import Row from './Row';

const Rows = ({ rows, colSize, textAlign, ...props }) => {
  return (
    <React.Fragment>
      { rows.map((row, index) => (
        <Row
          data={ row }
          key={ `table-row-${index}` }
          colSize={ colSize }
          textAlign={ textAlign }
          { ...props }
        />
      )) }
    </React.Fragment>
  );
};

Rows.propTypes = {
  rows: PropTypes.array.isRequired,
  colSize: PropTypes.array,
  textAlign: PropTypes.array
};

Rows.defaultProps = {
  rows: [],
  colSize: [],
  textAlign: []
};

export default Rows;
